import { render, staticRenderFns } from "./PedidoScreenReportes.vue?vue&type=template&id=bbcdbd4a&lang=html"
import script from "./PedidoScreenReportes.vue?vue&type=script&lang=js"
export * from "./PedidoScreenReportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports